import React, {useEffect, useReducer, useRef} from "react";
import {useLocation} from "react-router-dom";
import {verifyUser} from "../authRequests";
import {patientReducer, init} from "../additional_files/reducer";
import Layout from "../components/Layout";
import ConsentSigner from "../components/Consents/ConsentSigner";
import {Box, VStack, Heading, Text} from "@chakra-ui/react";

// Consent page. Reached from the "Please sign your …" notification (which deep
// links here) and from the pending-consent banner in Forms.
export default function Consents() {
  const loadedRef = useRef(null);
  const {state} = useLocation();
  const [dashState, dispatch] = useReducer(patientReducer, state, init);
  const sessionStart = useRef(true);

  useEffect(function () {
    verifyUser(state ? state.jwt : "", loadedRef);
  }, []);

  useEffect(() => {
    if (!sessionStart.current) {
      dispatch({type: "UPDATE_STATE", payload: state});
    }
  }, [state, dispatch]);

  useEffect(() => {
    sessionStart.current = false;
  }, []);

  return (
    <Layout state={{...dashState}} dispatch={dispatch}>
      <VStack
        ref={loadedRef}
        style={{opacity: 0}}
        flex={1}
        w="100%"
        overflow="auto"
        align="stretch"
      >
        <Box
          w="100%"
          flex={1}
          px={{base: 4, md: 6}}
          py={5}
          display="flex"
          flexDirection="column"
        >
          <Box mb={4}>
            <Heading fontSize="xl" fontWeight="600" color="#1a1f36">
              Consents
            </Heading>
            <Text fontSize="13px" color="#6b7280" mt={1}>
              Review and sign the authorizations your clinic needs
            </Text>
          </Box>
          <Box maxW="900px">
            <ConsentSigner state={dashState} />
          </Box>
        </Box>
      </VStack>
    </Layout>
  );
}
